import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { defaultChatBotSettings } from "../../consts/settings";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const INK = "#171717";

function luminance(hex) {
  const value = String(hex || "").trim().replace("#", "");
  const full = value.length === 3 ? value.split("").map(c => c + c).join("") : value;
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  const [r, g, b] = [0, 2, 4].map(i => {
    const channel = parseInt(full.slice(i, i + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/**
 * Filled actions keep the configured brand color. Text accents fall back to a
 * readable foreground when that brand is too close to the chat background.
 */
export function accentStyle(settings = {}) {
  const brand = settings.primaryColor || settings.headerBackgroundColor || defaultChatBotSettings.primaryColor;
  const brandLum = luminance(brand);
  const dark = isDarkChat(settings);
  const text = settings.headerTextColor;
  const textLum = luminance(text);
  const readable = value => value !== null && (dark ? value >= 0.18 : value < 0.6);
  const accent = readable(brandLum) ? brand : readable(textLum) ? text : dark ? "#f5f5f5" : INK;
  const foreground = color => luminance(color) > 0.179 ? INK : "#fff";
  return {
    "--chat-accent": accent,
    "--chat-on-accent": foreground(accent),
    "--chat-action": brand,
    "--chat-on-action": foreground(brand),
  };
}

export function isDarkChat(settings = {}) {
  const value = luminance(settings.chatWindowBackgroundColor);
  return value !== null && value < 0.18;
}

// Keep all message types on the same palette, including configured light widgets.
export function chatThemeStyle(settings = {}) {
  const dark = isDarkChat(settings);
  return {
    ...accentStyle(settings),
    colorScheme: dark ? "dark" : "light",
    "--chat-surface": settings.chatWindowBackgroundColor || "#fff",
    "--chat-raised": dark ? "#202020" : "#f6f6f7",
    "--chat-panel": dark ? "#191919" : "#fff",
    "--chat-ink": dark ? "#f5f5f5" : "#171717",
    "--chat-muted": dark ? "#a3a3a3" : "#737373",
    "--chat-border": dark ? "#303030" : "#e8e8e8",
    "--chat-error": dark ? "#fca5a5" : "#b91c1c",
  };
}
